<template>
  <div class="home">
    <list-page/>
  </div>
</template>

<script>
// @ is an alias to /src


import ListPage from "@/components/page/HomeView/content/list-page.vue";

export default {
  name: 'HomeView',
  components: {ListPage},
  mounted() {
    document.body.style.overflow = 'visible';

    document.title = "\"Ноофен-2024\" Сансрын даалгавар";

    let meta = document.querySelector("meta[name='description']");
    if (meta) {
      meta.setAttribute('content', 'Сансарт нисэхэд сансрын нисэгчдийг бэлтгэх ажлыг удирдан чиглүүлж, одод руу аялах замдаа мэдрэл сульдлыг даван туулцгаая');
    } else {
      meta = document.createElement('meta');
      meta.name = "description";
      meta.content = "Сансарт нисэхэд сансрын нисэгчдийг бэлтгэх ажлыг удирдан чиглүүлж, одод руу аялах замдаа мэдрэл сульдлыг даван туулцгаая";
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
    window.scrollTo(0, 0);

  },

}
</script>

<style lang="scss" scoped>
</style>
